import { useEffect, useRef } from 'react';
import { throttle } from 'lodash';

export default function SessionTimer() {
  const sessionTimerId = useRef<NodeJS.Timeout | undefined>();

  const autoLogout = () => {
    window.location.href = `https://www3.troweprice.com/aaweb1/accountAccess/page/logout.otc`;
  };

  const restartSessionTimer = throttle(() => {
    const logoutMilliseconds = 1000 * 60 * 25; // 25 min

    if (sessionTimerId.current) {
      clearTimeout(sessionTimerId.current);
    }
    sessionTimerId.current = setTimeout(autoLogout, logoutMilliseconds);
  }, 5000);

  useEffect(() => {
    restartSessionTimer();
    const body = document.getElementsByTagName('body')[0];
    body.addEventListener('mousemove', restartSessionTimer, true);
    body.addEventListener('keypress', restartSessionTimer, true);

    return () => {
      body.removeEventListener('mousemove', restartSessionTimer);
      body.removeEventListener('keypress', restartSessionTimer);
    };
  }, [restartSessionTimer]);

  // We have no UI right now but still using React component pattern because
  // we will have a UI with a warning pop up in the future and component
  // provides easier integration with app
  return null;
}
